/* Built In Imports */

/* External Imports */
import {
  Box,
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  chakra,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';
import SectionTitle from '@components/uyirnokkam/UymSectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */

/**
 * Renders the Card Circular 2 Column Group Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} lang - Current User Language.
 * @param {string} region - Current User Country.
 * @param sectionContent.region
 * @param sectionContent.lang
 * @returns {ReactElement} UymImportance Card component
 */
const UymFaq = ({ sectionContent, region, lang, pageConfig }) => {
  const FaqSection = ({
    faqSection,
    region,
    lang,
    bgColor,
    color,
    pageConfig,
  }) => {
    const pName = pageConfig?.pageName;

    return (
      <Box
        fontFamily={'MuktaMlalar'}
        fontSize="1.1rem"
        lineHeight="1.61"
        width="100%"
        m="0"
        id={faqSection?.id}
        mt={{base:'16px', md: '16px'}}
      >
        <Accordion
          key={nanoid()}
          allowMultiple
          m={{ base: '0 auto' }}
          width={{ base: '100%' }}
        >
          <AccordionItem border="none">
            <AccordionButton
              bgColor={bgColor || '#3F4D2A'}
              borderRadius="3px"
              mb="2px"
              fontFamily={'MuktaMlalar'}
              fontSize={{ base: '20px', md: '24px' }}
              fontWeight={'600'}
              border="none"
              padding={{base:'10px 18px 10px 20px', md:'10px 20px 10px 20px'}}
              color={color || 'white'}
              _hover={{
                bgColor: bgColor || '#3F4D2A',
                color: color || 'white',
              }}
              _focus={{ shadow: 'transparent' }}
              minHeight={{base:'58px', md:'70px'}}
              lineHeight="1.5"
              className='arrowIcon'
            >
              <chakra.div flex="1" textAlign="left">
                {faqSection.title}
              </chakra.div>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={1}>
              {faqSection?.faqs?.length
                ? faqSection.faqs.map((faq, index) => {
                    return (
                      <FaqChildren
                        faq={faq}
                        region={region}
                        lang={lang}
                        indx={faqSection?.faqs?.length-index}
                      />
                    );
                  })
                : null}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
    );
  };
  return (
    <Box width={{base:'90%', md:'100%'}} h="100%" mx="auto">
      <Box pt={{ base: '10px', md: '10px' }} pb={{ base: '20px', md: '30px' }}>
        <SectionTitle titleObj={sectionContent[0]} lang={lang} />
      </Box>
      <MidContainer w={'1049'}>
        {sectionContent.map((section, index) => {
          if (section._modelApiKey === 'faq_section_v2') {
            return (
              <FaqSection
                faqSection={section}
                region={region}
                lang={lang}
                pageConfig={pageConfig}
              />
            );
          }
        })}
      </MidContainer>
    </Box>
  );
};

const FaqChildren = ({ faq, region, lang, indx }) => {
  return (
    <AccordionItem
      key={nanoid(4)}
      borderBottomWidth="1px"
      borderBottomColor="#8484848A"
      borderTop="none"
      lineHeight="1.61"
      padding={{base:'15px 0', md:'15px'}}
      borderBottom={ indx == 1 && 'none !important' }
    >
      <AccordionButton
        p="0"
        fontFamily={'MuktaMlalar'}
        fontWeight={'600'}
        fontSize={{ base: '18px', md: '18px' }}
        borderTop="none"
        color="#000000"
        _hover={{ background: 'none' }}
        _focus={{ shadow: 'transparent' }}
        alignItems={'start'}
        className='arrowIcon'
      >
        <chakra.div flex="1" textAlign="left" key={nanoid(4)}>
          {faq.question}
        </chakra.div>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel
        p="0"
        pb={2}
        fontSize="1.1rem"
        fontFamily={'MuktaMlalar'}
        lineHeight="1.61"
      >
        <Box
          display="block"
          width="100%"
          lineHeight={{ base: '22px', md: '32px' }}
          fontSize={'16px'}
          color="#000000"
          p="0"
        >
          <Box className="answer-text">
            <StructuredTextParser
              str={render(faq.answer)}
              region={region}
              lang={lang}
            />
          </Box>
        </Box>
      </AccordionPanel>
      <style global jsx>
        {`
          .faq a {
            color: #cf4520;
          }
          .faq span.setting:after {
            font-family: fontawesome;
            font-size: 24px;
            content: '\f013';
            color: #fff;
            background: rgba(31, 41, 55, var(--tw-bg-opacity));
            border-radius: 18px;
            padding: 7px 8px 6px;
            --tw-bg-opacity: 1;
            vertical-align: middle;
          }
          .faq ul {
            padding-left: 1.5em;
          }
          .faq p {
            padding-bottom: 20px;
          }
          .answer-text {
            font-size: 16px;
            font-weight: 400;
          }
          @media (max-width: 768px) {
            .arrowIcon svg {
              width: 1.5em;
              height: 1.5em;
            }
          }
        `}
      </style>
    </AccordionItem>
  );
};

export default UymFaq;
